/**
 * Resolves opacity value from style format to a number between 0 and 1
 * Handles:
 * - Utility class names like "opacity-10" (10% = 0.1)
 * - Custom values like "0.5" or "50%"
 * - StyleValue objects like { custom: "0.75" } or { all: "opacity-50" }
 */
export const resolveOverlayOpacity = (opacity?: string, fallback = 0.75): number => {
  if (!opacity) {
    return fallback;
  }
  // Handle string format
  return parseOpacityValue(opacity, fallback);
};

/**
 * Parses opacity value from string format to number
 */
function parseOpacityValue(value: string, fallback: number): number {
  // Handle utility class names like "opacity-10", "opacity-50", etc.
  const utilityClassMatch = value.match(/^opacity-(\d+)$/);
  if (utilityClassMatch) {
    const percentage = parseInt(utilityClassMatch[1], 10);
    return Math.max(0, Math.min(1, percentage / 100));
  }

  // Handle percentage strings like "50%", "0.5%"
  if (value.endsWith('%')) {
    const percentage = parseFloat(value.slice(0, -1));
    if (!Number.isNaN(percentage)) {
      return Math.max(0, Math.min(1, percentage / 100));
    }
  }

  // Handle decimal strings like "0.5", "0.75"
  const decimal = parseFloat(value);
  if (!Number.isNaN(decimal)) {
    return Math.max(0, Math.min(1, decimal));
  }

  return fallback;
}
